"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[69],{

/***/ 7069:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ overlay)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function overlay({ wrapper }) {
  
  (function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('overlay:show', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).addClass('tw-on')
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('overlay:hide', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).removeClass('tw-on')
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close')
    })

    // TODO - add escape key listener
  })()
}

/***/ })

}]);